export var initialPageCache = {
    epgCache: null,
    topPicksCache: null,
};
export var initialState = function (origin) { return ({
    pageError: null,
    pageCache: initialPageCache,
    origin: origin,
    navConfig: {
        isShown: true,
        hideFooter: false,
    },
    headCache: null,
}); };
